
            const data = {"name":"ionicons/menu-sharp","data":{"width":"512","height":"512","viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M64 384h384v-42.67H64zm0-106.67h384v-42.66H64zM64 128v42.67h384V128z\"/>"}}
        
                module.exports = data
                